import React, { useState } from 'react';
import { X, ChevronLeft, ArrowRight, Plus } from 'lucide-react';
import AddFollowup from '../../pages/Enquiries/Forms/AddFollowup';
import AddFollowupForm from '../../pages/Enquiries/Forms/AddFollowupForm';
import PopUpModal from '../PopUpModal/PopUpModal';
import Button from '../common/Button';
import { mergeLeadToLeadNew, searchLeadByLeadNo } from '../../utils/lead';
import { getSession } from '../../getSession';
import Swal from 'sweetalert2';

const MergeLead = ({ isOpen, onClose, enquiryData, page }) => {
  const [selectedLeadId, setSelectedLeadId] = useState('');
  const [selectedFields, setSelectedFields] = useState({});
  const [showFollowupForm, setShowFollowupForm] = useState(false);
  const [keepLead, setKeepLead] = useState(1);
  const [searchLeadNo, setSearchLeadNo] = useState('');
  const [lead2Data, setLead2Data] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [mergeData, setMergeData] = useState({
    name: '',
    company: '',
    phone: '',
    mobile1: '',
    mobile2: '',
    email: '',
    email1: '',
    email2: '',
    country: '',
    state: '',
    city: '',
    pincode: '',
    residentialAddress: '',
    officeAddress: '',
  });
  const [fieldsList, setFieldsList] = useState([]);

  // Mock data - replace with actual API data
  const leadOptions = [
    { id: '136961', name: 'Lead 136961' },
    { id: '136962', name: 'Lead 136962' },
    { id: '136963', name: 'Lead 136963' },
  ];

  React.useEffect(() => {
    if (enquiryData && Object.keys(selectedFields).length === 0) {
      const initialMergeData = {
        name: enquiryData.PersonName || enquiryData.Name || '',
        company: enquiryData.CompanyName || enquiryData.Company || '',
        phone: enquiryData.MobileNo || enquiryData.Phone || '',
        mobile1: enquiryData.MobileNo1 || enquiryData.Mobile1 || '',
        mobile2: enquiryData.MobileNo2 || enquiryData.Mobile2 || '',
        email: enquiryData.EmailId || enquiryData.Email || '',
        email1: enquiryData.EmailId1 || enquiryData.Email1 || '',
        email2: enquiryData.EmailId2 || enquiryData.Email2 || '',
        country: enquiryData.Country || '',
        state: enquiryData.State || '',
        city: enquiryData.City || '',
        pincode: enquiryData.PinCode || enquiryData.Pincode || '',
        residentialAddress: enquiryData.Address1 || enquiryData.ResidentialAddress || '',
        officeAddress: enquiryData.Address2 || enquiryData.OfficeAddress || '',
      };

      setMergeData(initialMergeData);

      const initialSelected = {};
      Object.keys(initialMergeData).forEach(key => {
        initialSelected[key] = 'enquiry';
      });
      setSelectedFields(initialSelected);
    }
  }, [enquiryData]);

  React.useEffect(() => {
    if (enquiryData) {
      const enqMapped = {
        name: enquiryData.PersonName || enquiryData.Name || '',
        company: enquiryData.CompanyName || enquiryData.Company || '',
        phone: enquiryData.MobileNo || enquiryData.Phone || '',
        mobile1: enquiryData.MobileNo1 || enquiryData.Mobile1 || '',
        mobile2: enquiryData.MobileNo2 || enquiryData.Mobile2 || '',
        email: enquiryData.EmailId || enquiryData.Email || '',
        email1: enquiryData.EmailId1 || enquiryData.Email1 || '',
        email2: enquiryData.EmailId2 || enquiryData.Email2 || '',
        country: enquiryData.Country || '',
        state: enquiryData.State || '',
        city: enquiryData.City || '',
        pincode: enquiryData.PinCode || enquiryData.Pincode || '',
        residentialAddress: enquiryData.Address1 || enquiryData.ResidentialAddress || '',
        officeAddress: enquiryData.Address2 || enquiryData.OfficeAddress || '',
      };

      const lead2Mapped = lead2Data ? {
        name: lead2Data.PersonName || lead2Data.Name || lead2Data.personname || lead2Data.name || '',
        company: lead2Data.CompanyName || lead2Data.Company || lead2Data.companyname || lead2Data.company || '',
        phone: lead2Data.MobileNo || lead2Data.Phone || lead2Data.mobileno || lead2Data.phone || '',
        mobile1: lead2Data.MobileNo1 || lead2Data.Mobile1 || lead2Data.mobileno1 || lead2Data.mobile1 || '',
        mobile2: lead2Data.MobileNo2 || lead2Data.Mobile2 || lead2Data.mobileno2 || lead2Data.mobile2 || '',
        email: lead2Data.EmailId || lead2Data.Email || lead2Data.emailid || lead2Data.email || '',
        email1: lead2Data.EmailId1 || lead2Data.Email1 || lead2Data.emailid1 || lead2Data.email1 || '',
        email2: lead2Data.EmailId2 || lead2Data.Email2 || lead2Data.emailid2 || lead2Data.email2 || '',
        country: lead2Data.Country || lead2Data.country || '',
        state: lead2Data.State || lead2Data.state || '',
        city: lead2Data.City || lead2Data.city || '',
        pincode: lead2Data.PinCode || lead2Data.Pincode || lead2Data.pincode || '',
        residentialAddress: lead2Data.Address1 || lead2Data.ResidentialAddress || lead2Data.residentialaddress || lead2Data.address1 || '',
        officeAddress: lead2Data.Address2 || lead2Data.OfficeAddress || lead2Data.officeaddress || lead2Data.address2 || '',
      } : {};

      const generatedFieldsList = [
        { id: 'name', placeholder: 'Name' },
        { id: 'company', placeholder: 'Company' },
        { id: 'phone', placeholder: 'Phone' },
        { id: 'mobile1', placeholder: 'Mobile 1' },
        { id: 'mobile2', placeholder: 'Mobile 2' },
        { id: 'email', placeholder: 'Email' },
        { id: 'email1', placeholder: 'Email 1' },
        { id: 'email2', placeholder: 'Email 2' },
        { id: 'country', placeholder: 'Country' },
        { id: 'state', placeholder: 'State' },
        { id: 'city', placeholder: 'City' },
        { id: 'pincode', placeholder: 'Pincode' },
        { id: 'residentialAddress', placeholder: 'Residential Address' },
        { id: 'officeAddress', placeholder: 'Office Address' },
      ].map(field => ({
        ...field,
        enquiry: { label: enqMapped[field.id] || '', value: enqMapped[field.id] || '' },
        lead: { label: lead2Mapped[field.id] || '', value: lead2Mapped[field.id] || '' },
      }));

      setFieldsList(generatedFieldsList);
    }
  }, [enquiryData, lead2Data]);


  const handleEnquiryFieldSelect = (fieldId, value) => {
    setSelectedFields(prev => ({
      ...prev,
      [fieldId]: 'enquiry'
    }));
    setMergeData(prev => ({
      ...prev,
      [fieldId]: value || ''
    }));
  };

  const handleLeadFieldSelect = (fieldId, value) => {
    setSelectedFields(prev => ({
      ...prev,
      [fieldId]: 'lead'
    }));
    setMergeData(prev => ({
      ...prev,
      [fieldId]: value || ''
    }));
  };

  const handleMergeDataChange = (fieldId, value) => {
    setMergeData(prev => ({
      ...prev,
      [fieldId]: value
    }));
  };

  const handleMergeSubmit = async () => {
    if (!selectedLeadId) {
      Swal.fire('Warning', 'Please select or search for Lead 2 to merge with', 'warning');
      return;
    }

    const { TokenId, userId, parentId } = getSession();

    const detailsObj = {
      LeadId1: enquiryData?.LeadId || enquiryData?.ID || enquiryData?.EnquiryId || 0,
      LeadId2: selectedLeadId,
      ParentID: enquiryData?.ParentID || 0,

      MobileNo1: mergeData.phone,
      MobileNo2: mergeData.mobile1,
      MobileNo3: mergeData.mobile2,

      EmailID1: mergeData.email,
      EmailID2: mergeData.email1,
      EmailID3: mergeData.email2,

      PersonName: mergeData.name,
      CompanyName: mergeData.company,
      City: mergeData.city,
      State: mergeData.state,
      Country: mergeData.country,
      PinCode: mergeData.pincode,
      ResidentialAddress: mergeData.residentialAddress,
      OfficeAddress: mergeData.officeAddress,

      ModifiedBy: userId,
      keepLead: keepLead,

      CountryCode1: '',
      CountryCode2: '',
      CountryCode3: '',

      SourceName: enquiryData?.SourceName || '',
      MediumName: enquiryData?.MediumName || '',
      CampaignName: enquiryData?.CampaignName || '',

      lstCustomField: [],
      followUp: null
    };

    const payload = {
      Token: TokenId,
      Message: '',
      LoggedUserId: userId,
      MAC_Address: '',
      IP_Address: '',
      Details: JSON.stringify(detailsObj),
      BroadcastName: ''
    };

    try {
      const response = await mergeLeadToLeadNew(payload);
      if (response && response.Status === 1) {
        Swal.fire('Success', response.Message || 'Merged Successfully', 'success');
        onClose();
      } else {
        Swal.fire('Error', response?.Message || 'Conflicts Found or Error Occurred', 'error');
      }
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Something went wrong while merging leads', 'error');
    }
  };

  const handleSearchLead = async () => {
    if (!searchLeadNo) {
      Swal.fire('Warning', 'Please enter a Lead No to search', 'warning');
      return;
    }
    setIsSearching(true);
    const { TokenId, userId, parentId } = getSession();

    const detailsObj = {
      LeadNo: parseInt(searchLeadNo) || 0,
      ParentId: parentId
    };

    const payload = {
      Token: TokenId,
      Message: '',
      LoggedUserId: userId,
      MAC_Address: '',
      IP_Address: "102.16.32.189",
      Details: detailsObj,
      BroadcastName: ''
    };

    try {
      const response = await searchLeadByLeadNo(payload);
      if (response && response.Status === 1 && response.Details) {
        let parsedDetails = response.Details;
        if (typeof parsedDetails === 'string') {
          try {
            parsedDetails = JSON.parse(parsedDetails);
          } catch (e) { }
        }

        if (Array.isArray(parsedDetails) && parsedDetails.length > 0) {
          const lead = parsedDetails[0];
          setLead2Data(lead);
          setSelectedLeadId(lead.LeadId || lead.ID || lead.LeadNo || lead.EnquiryId || lead.id || lead.leadno);
          Swal.fire({
            icon: 'success',
            title: 'Lead Found',
            text: `Successfully loaded lead: ${lead.PersonName || lead.Name || lead.personname || lead.name || 'Unknown'} - ${lead.MobileNo || lead.mobileno || ''}`,
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          Swal.fire('Not Found', 'No lead found with this Lead No', 'info');
          setLead2Data(null);
        }
      } else {
        Swal.fire('Error', response?.Message || 'Failed to search lead', 'error');
      }
    } catch (err) {
      console.error('searchLead error:', err);
      Swal.fire('Error', 'Something went wrong', 'error');
    } finally {
      setIsSearching(false);
    }
  };

  const handleMergeAndFollowup = () => {
    console.log('Merge & Add Followup clicked');
    setShowFollowupForm(true);
    console.log('showFollowupForm set to true');
  };

  const handleFollowupClose = () => {
    setShowFollowupForm(false);
    onClose();
  };

  // console.log('MergeLead render - showFollowupForm:', showFollowupForm);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-full max-w-6xl bg-white shadow-2xl z-50 transform transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-50">
          <div className="flex items-center gap-3">
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-200 rounded transition"
            >
              <ChevronLeft className="w-5 h-5 text-gray-600" />
            </button>
            <h2 className="text-xl font-semibold text-gray-800">Merge {page === 'lead' ? 'Lead' : 'Enquiry'} to Lead</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-200 rounded transition"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {page === "lead" && (
          <div className="px-6 py-4  flex justify-center border-b border-gray-200">
            <div className="flex flex-col gap-3">
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <input
                  type="radio"
                  name="mergeOption"
                  checked={keepLead === 1}
                  onChange={() => setKeepLead(1)}
                  className="w-4 h-4 text-green-600"
                />
                Keep Lead 1 and Delete Lead 2
              </label>

              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <input
                  type="radio"
                  name="mergeOption"
                  checked={keepLead === 2}
                  onChange={() => setKeepLead(2)}
                  className="w-4 h-4 text-green-600"
                />
                Keep Lead 2 and Delete Lead 1
              </label>
            </div>
          </div>
        )}

        {/* Lead No & Search */}
        {page === "lead" && (
          <div className="px-6 py-4 border-b border-gray-200 flex items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-gray-700">
                Lead No.
              </span>
              <span className="px-3 py-1 bg-green-600 text-white rounded-full text-sm font-semibold">
                {enquiryData?.LeadNo || enquiryData?.LeadId || enquiryData?.ID || enquiryData?.EnquiryId || 'N/A'}
              </span>
            </div>

            <div className="flex items-center ml-auto max-w-md w-full">
              <input
                type="text"
                value={searchLeadNo}
                onChange={(e) => setSearchLeadNo(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') handleSearchLead(); }}
                placeholder="Search lead no"
                className="flex-1 border border-gray-300 rounded-l px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <button
                onClick={handleSearchLead}
                disabled={isSearching}
                className="bg-green-600 px-4 py-[6.5px] rounded-r text-white hover:bg-green-700 transition disabled:opacity-50"
              >
                {isSearching ? '...' : '🔍'}
              </button>
            </div>
          </div>
        )}
        {/* Enquiry ID Badge */}
        {page !== "lead" && (<div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-gray-600">{page === 'lead' ? 'Lead' : 'Enquiry'} ID.</span>
            <span className="px-3 py-1 bg-green-500 text-white rounded-full text-sm font-medium">
              {enquiryData?.EnquiryNo || enquiryData?.LeadNo || enquiryData?.EnquiryId || enquiryData?.ID || enquiryData?.LeadId || 'N/A'}
            </span>
            <select
              value={selectedLeadId}
              onChange={(e) => setSelectedLeadId(e.target.value)}
              className="ml-4 flex-1 max-w-md border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {leadOptions.map((lead) => (
                <option key={lead.id} value={lead.id}>
                  {lead.id}
                </option>
              ))}
            </select>
          </div>
        </div>)}

        {/* Three Column Layout */}
        <div className="relative h-[calc(100vh-220px)] overflow-y-auto">
          {/* Header Section with Profile Images */}
          <div className="grid grid-cols-3 border-b border-gray-200 sticky top-0 bg-white z-10">
            {/* Enquiry Details Header */}
            <div className="border-r border-gray-200 p-6">
              <div className="flex flex-col items-center">
                <div className="w-24 h-24 rounded-full overflow-hidden mb-3">
                  <img
                    src={enquiryData?.Image || enquiryData?.ProfilePicturePath || "https://docs.kit19.com/default/person.png"}
                    alt="Enquiry"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="details"
                    id="enquiry-details"
                    defaultChecked
                    className="w-4 h-4"
                  />
                  <label htmlFor="enquiry-details" className="font-semibold text-gray-800">
                    {page === 'lead' ? 'Lead' : 'Enquiry'} Details
                  </label>
                </div>
              </div>
            </div>

            {/* Lead Details Header */}
            <div className="border-r border-gray-200 p-6">
              <div className="flex flex-col items-center">
                <div className="w-24 h-24 rounded-full overflow-hidden mb-3">
                  <img
                    src={lead2Data?.Image || lead2Data?.ProfilePicturePath || lead2Data?.ProfileImgFileName || "https://docs.kit19.com/default/person.png"}
                    alt="Lead"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="details"
                    id="lead-details"
                    className="w-4 h-4"
                  />
                  <label htmlFor="lead-details" className="font-semibold text-gray-800">
                    Lead Details
                  </label>
                </div>
                {selectedLeadId && (
                  <p className="text-sm text-gray-600 mt-2">
                    Assigned To: <span className="font-medium">{lead2Data?.AssignedUser || lead2Data?.AssignedTo || lead2Data?.assigned_to || 'N/A'}</span>
                  </p>
                )}
              </div>
            </div>

            {/* Merge Details Header */}
            <div className="p-6">
              <div className="flex flex-col items-center">
                <div className="w-24 h-24 rounded-full overflow-hidden mb-3">
                  <img
                    src="https://docs.kit19.com/default/person.png"
                    alt="Merge"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="font-semibold text-gray-800">Merge Details</h3>
              </div>
            </div>
          </div>

          {/* Fields Section - All in aligned rows */}
          <div className="relative">
            {fieldsList.map((field, index) => (
              <div
                key={field.id}
                className="grid grid-cols-3 border-b border-gray-100 hover:bg-gray-50 transition-colors"
              >
                {/* Enquiry Field */}
                <div className="border-r border-gray-200 px-6 py-3 flex items-center">
                  <input
                    type="radio"
                    name={`field-${field.id}`}
                    value="enquiry"
                    checked={selectedFields[field.id] === 'enquiry'}
                    onChange={() => handleEnquiryFieldSelect(field.id, field.enquiry.value)}
                    className="w-4 h-4 cursor-pointer flex-shrink-0"
                  />
                  <span className="text-sm text-gray-700 ml-3">
                    {field.enquiry.label || <span className="text-gray-400">Empty</span>}
                  </span>
                </div>

                {/* Lead Field */}
                <div className="border-r border-gray-200 px-6 py-3 flex items-center">
                  <input
                    type="radio"
                    name={`field-${field.id}`}
                    value="lead"
                    checked={selectedFields[field.id] === 'lead'}
                    onChange={() => handleLeadFieldSelect(field.id, field.lead.value)}
                    className="w-4 h-4 cursor-pointer flex-shrink-0"
                  />
                  <span className="text-sm text-gray-700 ml-3">
                    {field.lead.label || <span className="text-gray-400">Empty</span>}
                  </span>
                </div>

                {/* Merge Field (Input) */}
                <div className="px-6 py-2">
                  <input
                    type="text"
                    placeholder={field.placeholder}
                    value={mergeData[field.id]}
                    onChange={(e) => handleMergeDataChange(field.id, e.target.value)}
                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            ))}

            {/* Plus Button - positioned between first and second column */}
            <div className="absolute top-[50%] left-[calc(33.333%-24px)] ">
              <button className="w-12 h-12 bg-gray-400 text-white rounded-full flex items-center justify-center hover:bg-gray-500 transition shadow-lg">
                <Plus className="w-6 h-6" />
              </button>
            </div>

            {/* Arrow Button - positioned between second and third column */}
            <div className="absolute top-[50%] left-[calc(66.666%-24px)] ">
              <button className="w-12 h-12 bg-gray-400 text-white rounded-full flex items-center justify-center hover:bg-gray-500 transition shadow-lg">
                <ArrowRight className="w-6 h-6" />
              </button>
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="absolute bottom-0 left-0 right-0 px-6 py-4 bg-white border-t border-gray-200 flex items-center gap-3">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-green-600 text-green-600 rounded hover:bg-green-50 transition font-medium"
          >
            Cancel
          </button>
          <button
            onClick={handleMergeSubmit}
            className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition font-medium"
          >
            Merge {page === 'lead' ? 'Lead' : 'to Lead'}
          </button>
          <button
            onClick={() => setShowFollowupForm(true)}
            className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition font-medium"
          >
            Merge & Add Follow up
          </button>
        </div>
      </div>

      <PopUpModal
        isOpen={showFollowupForm}
        onClose={handleFollowupClose}
        title="Add Lead"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={handleFollowupClose}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={handleFollowupClose}
            >
              Save
            </Button>
          </div>
        }
      >
        <AddFollowupForm selectedCount={enquiryData} />
      </PopUpModal>


    </>
  );
};

export default MergeLead;
